module.exports = __webpack_public_path__ + "static/media/tr.a270485a.svg";